module.exports = __webpack_public_path__ + "static/img/dy1-1.eaeada6.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy1-1.png
// module id = 935
// module chunks = 0